/**
 * @generated SignedSource<<29580b0bb9d5cf75fa50b45a4d92921f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueTimelinePaginated$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineBackPaginated" | "IssueTimelineFrontPaginated">;
  readonly " $fragmentType": "IssueTimelinePaginated";
};
export type IssueTimelinePaginated$key = {
  readonly " $data"?: IssueTimelinePaginated$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTimelinePaginated">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "numberOfTimelineItems"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTimelinePaginated",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "numberOfTimelineItems",
          "variableName": "numberOfTimelineItems"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueTimelineFrontPaginated"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "last",
          "value": 0
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueTimelineBackPaginated"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "978f89ddeadc9f7965ef49da8afe9abd";

export default node;
